// LIBRARIES
import {
  BORDER_RADIUS,
  COLORS,
  DEVICE_TYPE,
  MARGIN,
} from "constants/variables";
import styled from "styled-components";

//MISC;

export const VideoBackground = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
  border-radius: ${BORDER_RADIUS.radius24};
`;

export const ImageBackground = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
  border-radius: ${BORDER_RADIUS.radius24};
`;

interface CarouselContainerProps {
  isHomePage?: boolean;
}

export const CarouselContainer = styled.div<CarouselContainerProps>`
  width: 100%;
  height: 100%;
  border-radius: ${BORDER_RADIUS.radius24};
  /* background: transparent linear-gradient(270deg, #1d1d2629 0%, #1d1d26a3 100%)
    0% 0% no-repeat padding-box; */
  padding: ${MARGIN.max64};
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  position: relative;
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    padding: ${MARGIN.max200} ${MARGIN.max24} ${MARGIN.max24} ${MARGIN.max24};
    justify-content: ${(props) => (props.isHomePage ? "flex-end" : "flex-end")};
  }
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    padding: ${(props) => !props.isHomePage && MARGIN.max24};
    justify-content: ${(props) =>
      props.isHomePage ? "flex-end" : "flex-start"};
  }
`;

export const Header = styled.div`
  display: flex;
  margin-bottom: ${MARGIN.max24};
  height: 24px;
  gap: ${MARGIN.max24};
  z-index: 1;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  width: 563px;
  z-index: 1;
  position: relative;
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    width: 100%;
    height: 100%;
  }
`;

export const TitleContainer = styled.div`
  margin-bottom: ${MARGIN.fix16};
`;

export const InfoContainer = styled.div`
  margin-bottom: ${MARGIN.max40};
  display: -webkit-box;
  -webkit-line-clamp: 4;   /* ✅ max 5 rows */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${COLORS.Background};
`;

export const ButtonContainer = styled.div`
  margin-top: auto;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${MARGIN.max40};
  width: 100%;
  z-index: 1;
`;

export const Line = styled.div`
  display: flex;
  width: 880px;
  height: 2px;
  opacity: 32%;
  background-color: ${COLORS.Background};
  margin-bottom: ${MARGIN.max40};
  margin-top: ${MARGIN.max50};
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    width: 100%;
    margin-right: ${MARGIN.fix24};
  }
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    margin-bottom: ${MARGIN.fix24};
    margin-top: ${MARGIN.fix24};
  }
`;

export const FooterRow = styled.div``;

export const LeftSideWrapper = styled.div`
  display: flex;
  gap: ${MARGIN.fix16};
`;

export const Bullet = styled.img`
  width: 42px;
  height: 42px;
  border-radius: 50%;
  z-index: 1000;
`;

export const PlayButton = styled.div`
  background-color: white;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    background-color: ${COLORS.ChineseSilver};
    transition: 0.3s ease-in;
  }
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    width: 42px;
    height: 42px;
  }
`;

export const VideoPreview = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 42px;
  height: 42px;
  cursor: pointer;
`;

export const PlayImage = styled.img``;

export const CircularProgressBarContainer = styled.div`
  position: absolute;
  width: 42px;
  height: 42px;
`;
export const BgOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, rgb(29, 29, 38, 0.8) 20%, transparent 90%);
  border-radius: ${BORDER_RADIUS.radius24};
  z-index: 1;
`;
